import { BlockchainNetwork } from "../constants.js"
import { blockchains } from "../blockchains/networksConfig.js"
import { getBlockchainFromNetwork, getNetworkName } from "./getBlockchainFromNetwork.js"

export const isValidAddress = (address: string, blockchain: BlockchainNetwork) => {
    const blockchainName = getNetworkName(getBlockchainFromNetwork(blockchain))

    return blockchains.
        filter((b) => b.name === blockchainName || b.name === blockchain)
        .some((b2) => !!address.match(b2.regexp))
}

export function validateAddresses(addresses: string[], blockchain: BlockchainNetwork): string[] {
    const invalidAddresses = []

    for (const address of addresses) {
        if (!isValidAddress(address, blockchain)) {
            invalidAddresses.push(address)
        }
    }

    return invalidAddresses
}

export const isValidBlockchainAddress = (address: string, blockchain: BlockchainNetwork) =>
    isValidAddress(address, blockchain)
